module.exports = __webpack_public_path__ + "img/notdk.cc666359.png";